import { Box } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { IMAGE_INTERVAL_CHANGE } from "../../config";
import { ERoute, LOCAL_STORAGE_KEYS } from "../../constants";
import { useLocalStorage } from "../../hooks";

type TOwnProps = { toggleScreeSaver: (isShow: boolean) => void };

const ScreenSaver = (props: TOwnProps) => {
  const { toggleScreeSaver } = props;
  const navigate = useNavigate();
  const { screenSaver } = useLocalStorage();
  const [currentImageSrc, setCurrentImage] = useState<string>("");

  const imgSrc = useMemo(() => screenSaver?.mediaContents?.map((s) => ({
    id: s.id,
    src: s.backgroundImageSource || "/assets/images/fallback-screensaver.png",
  })), [screenSaver]);


  const handleNavigateHomeScreen = () => {
    const id = uuid();
    localStorage.setItem(LOCAL_STORAGE_KEYS.SESSIONS_ID, id);

    toggleScreeSaver(false);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      imgSrc &&
        setCurrentImage(imgSrc[Math.floor(Math.random() * imgSrc.length)].src);
    }, IMAGE_INTERVAL_CHANGE);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    navigate(ERoute.HOME);
  }, []);

  return (
    <Box display="flex" height="100%" width="100%">
      <img
        src={currentImageSrc}
        onError={(e) => {
          e.currentTarget.src = "assets/images/fallback-screensaver.png";
        }}
        height="100%"
        width="100%"
        alt="screen_image"
        style={{ objectFit: "fill" }}
        onClick={handleNavigateHomeScreen}
      />
    </Box>
  );
};
export default ScreenSaver;
